<div class="add-price-container">
  <h2>{{ dialogTitle() }}</h2>

  @if (isLoading()) {
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <p>{{ 'COMMON.STATES.LOADING' | translate }}</p>
    </div>
  } @else {
    @if (serverErrorMessage()) {
      <div class="error-alert">
        <mat-icon>error</mat-icon>
        <span>{{ serverErrorMessage() }}</span>
      </div>
    }

    <form [formGroup]="form" (ngSubmit)="submit()">
      <mat-form-field class="full-width">
        <mat-label>{{ 'ADD_PRICE.TARGET' | translate }}</mat-label>
        <input matInput [formControl]="form.controls.itemId" [matAutocomplete]="auto" required />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayItemFn" autoActiveFirstOption>
          @for (item of filteredItems | async; track item.id) {
            <mat-option [value]="item.id">{{ item.name[lang()] }}</mat-option>
          }
        </mat-autocomplete>
        @if (form.controls.itemId.hasError('required') && form.controls.itemId.touched) {
          <mat-error>{{ 'VALIDATION.PRODUCT_REQUIRED' | translate }}</mat-error>
        }
        @if (form.controls.itemId.hasError('invalidItem') && form.controls.itemId.touched) {
          <mat-error>{{ 'VALIDATION.INVALID_PRODUCT' | translate }}</mat-error>
        }
      </mat-form-field>

      <div class="form-row">
        <mat-form-field>
          <mat-label>{{ 'ADD_PRICE.PRICE' | translate }}</mat-label>
          <input matInput type="number" [formControl]="form.controls.price" min="0" step="0.01" required />
          @if (form.controls.price.hasError('required') && form.controls.price.touched) {
            <mat-error>{{ 'VALIDATION.PRICE_REQUIRED' | translate }}</mat-error>
          }
          @if (form.controls.price.hasError('min') && form.controls.price.touched) {
            <mat-error>{{ 'VALIDATION.PRICE_MINIMUM' | translate }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ 'ADD_PRICE.UNIT' | translate }}</mat-label>
          <mat-select formControlName="unit" required>
            @for (measure of measures(); track measure.id) {
              <mat-option [value]="measure.id">{{ measure.name }}</mat-option>
            }
          </mat-select>
          @if (form.controls.unit.hasError('required') && form.controls.unit.touched) {
            <mat-error>{{ 'VALIDATION.UNIT_REQUIRED' | translate }}</mat-error>
          }
        </mat-form-field>
      </div>

      <mat-form-field class="full-width">
        <mat-label>{{ 'ADD_PRICE.VALID_FROM' | translate }}</mat-label>
        <input matInput [matDatepicker]="picker" [formControl]="form.controls.validFrom" required [max]="maxDate()" />
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        @if (form.controls.validFrom.hasError('required') && form.controls.validFrom.touched) {
          <mat-error>{{ 'VALIDATION.DATE_REQUIRED' | translate }}</mat-error>
        }
      </mat-form-field>

      <div class="button-container">
        <button mat-button type="button" (click)="cancel()" [disabled]="isSubmitting()">{{ 'COMMON.ACTIONS.CANCEL' | translate }}</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid || isSubmitting()">
          @if (isSubmitting()) {
            <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
            {{ 'COMMON.STATES.PROCESSING' | translate }}
          } @else {
            {{ saveButtonText() }}
          }
        </button>
      </div>
    </form>
  }
</div>
